import { getEvents } from "@utils/aegean_api_handler";

export const GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_ERROR = "GET_EVENTS_ERROR";

export const fetchEvents = range => (dispatch) => {
  dispatch({
    type: GET_EVENTS_REQUEST,
    range
  });

  return getEvents(range)
    .then((result) => {
      dispatch({
        type: GET_EVENTS_SUCCESS,
        data: result,
        range
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_EVENTS_ERROR,
        error,
        range
      });
    });
};
